import * as React from 'react'
import { useState, useEffect } from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import styled from 'styled-components'
import { CookiesProvider } from 'react-cookie'
import { useCookies } from 'react-cookie'

import {ResetCss,expandCompressedFont} from './globalStyles'
import typekit from './typekit'
import Header from './header'
import kerning, { KString } from './kerning'

const Layout: React.FC<{ subComponent?: React.ReactNode | undefined }> = ({ children, subComponent }) => {
  useEffect(() => {
    if(document !== undefined){
      typekit(document,'dmd6rko')
    }
  }, [])


  const data = useStaticQuery<GatsbyTypes.SiteTitleQueryQuery & {
    file: {
      publicURL: string;
    }
  }>(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
      file(relativePath: {eq: "ACT_logo-01.svg"}) {
        publicURL
      }
    }
  `)

  const [about, switchAbout] = useState(false)

  const k = new kerning()

  k.defineTypes = [
    {
      type: 'postal-mark',
      target: new RegExp(/[〒]*/),
      styles: `
        margin: 0 0px 0 0 ;
      `
    },
    {
      type: 'nakaguro',
      target: new RegExp(/[・]*/),
      styles: `
        margin: 0 4px 0 0 ;
      `
    },
    {
      type: 'カギカッコopen',
      target: new RegExp(/[「]*/),
      styles: `
        margin: 0 0 0 4px;
      `
    },
    {
      type: 'カギカッコclose',
      target: new RegExp(/[」]*/),
      styles: `
        margin: 0px 8px 0px -4px;
      `
    },
    {
      type: 'スミカッコopen',
      target: new RegExp(/[【]*/),
      styles: `
        margin: 0 0 0 4px;
      `
    },
    ...k.defaultDefine,
  ]

  return (
    <>
      <CookiesProvider>
        <ResetCss />
        <>
          {subComponent || null}
        </>
        <Header siteTitle={data.site?.siteMetadata?.title || `Title`} />
        <div>
          <About isActive={about}>
            <section>
              <header>
                <p>
                  <span onClick={()=>switchAbout(false)}>
                    BACK
                  </span>
                </p>
              </header>
              <KString>
                <section>
                  <div className={'exh_information'}>
                    <h1>2121 SS/AW COLLECTION</h1>
                    <h2>Christopher Loden</h2>
                    <ul>
                      <li>
                        <h3>会期</h3>
                        <p>2022年4月15日- 4月22日</p>
                      </li>
                      <li>
                        <h3>時間</h3>
                        <p>14時~26時</p>
                      </li>
                      <li>
                        <h3>会場</h3>
                        <p className={'venue'}>デカメロン<br /><a href={'https://www.google.com/maps/place/%E3%83%87%E3%82%AB%E3%83%A1%E3%83%AD%E3%83%B3/@35.694941,139.7024,15z/data=!4m5!3m4!1s0x0:0x160cc8789327d1a7!8m2!3d35.694941!4d139.7024?hl=ja'} target={'_blank'} rel={'noopener noreferrer'} className={'venue_link'}>（〒160-0021 東京都新宿区歌舞伎町1丁目12-4 2F）</a></p>
                      </li>
                      <li>
                        <h3>TEL</h3>
                        <p className={'tel'}>03-6265-9013</p>
                      </li>
                      <li>
                        <h3>休み</h3>
                        <p>月曜日</p>
                      </li>
                      <li>
                        <h3>助成</h3>
                        <p className={'grants'}>
                          <span>公益財団法人東京都歴史文化財団 アーツカウンシル東京</span>
                          <span>【スタートアップ助成】<img src={data.file.publicURL} alt={'アーツカウンシル東京'} /></span>
                        </p>
                      </li>
                    </ul>
                    <p>
                      ※時間及び休廊日は、新型コロナウイルス感染拡大防止のための東京都における緊急事態措置、また飲食店に対する営業時間短縮要請に準じて変動する可能性があります。
                    </p>
                    <p>
                      詳しい情報はHP(<a href="https://decameron.jp/" target="_blank" rel="noopener noreferrer">https://decameron.jp/</a>)をご覧いただくか、ご来店の前にお電話にてご確認ください。
                    </p>
                  </div>
                  <div className={'exh_text'}>
                    <p>本展覧会企画は「現在とは離れた時間や世界の衣服を提示することで、人間の身体が変容・拡張・更新していく可能性を想像させること」にある。</p>
                    <p>私たちの身体は「ファッション」という概念を通じて、様々な社会状況や問題に順応し、時には状況そのものを変容させてきた。ハイヒールが物理的に身体の拡張を施し、我々の目を愉しませると同時に、着用者自身の行動に制限をかける機能を持つことは偶然ではないだろう。それほど直接的ではない制服やユニフォームなどにおいても、そこには社会や権力によって与えられる役割や命令が相互に作用しながら、次第に透明になるよう更新がなされてきた。</p>
                    <p>現在ではデジタルメディアの発展に従い、現実の私たちの肉体を前提とした「ファッション」とは異なる発展が垣間見れるようになる。デジタル加工や写真撮影を前提とした美容整形や、デジタルプラットフォーム上におけるアバターなど、「ファッション」のあり方は私たちの肉体を基準とすることを放棄し始め、画面上の平面や記号性へとその戦場を移そうとしているといえる。</p>
                    <p>私たちの身体によって装いやファッションを規定するのではなく、メディアや置かれている環境によるファッションから身体を捉えることで、私たちの身体変容の可能性について図ることを試みる。</p>
                  </div>
                </section>
              </KString>
            </section>
          </About>
          <main>{children}</main>
          <Footer>
            <p>©️ 2022 Christopher Loden</p>
            <p>
              <span onClick={()=>switchAbout(true)}>
                ABOUT THIS WEBSITE
              </span>
            </p>
          </Footer>
        </div>
      </CookiesProvider>
    </>
  )
}

type enableDisplaySwitch = {
  isActive?: boolean;
}

const About = styled.section<enableDisplaySwitch>`
  display: ${(props) => props.isActive ? 'block' : 'none'};
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 2;
  top: 0;
  right: 0;
  background: #000000;
  padding: 0 60px;
  box-sizing: border-box;
  overflow: scroll;
  *{
    color: #FFFFFF;
  }
  @media (max-width:768px) {
    padding: 0 19px 80px 20px;
  }
  & > section > header{
    padding: 38px 0 0 0;
    height: 140px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    @media (max-width:768px) {
      padding: 19px 0 0 0;
      height: 81px;
    }
    p{
      ${expandCompressedFont}
      line-height: inherit;
      vertical-align: baseline;
      span{
        font-size: 20px;
        letter-spacing: -0.3px;
        padding: 0 0 4px 0;
        cursor: pointer;
        border-bottom: 1px solid #FFFFFF;
        color: #FFFFFF;
        cursor: pointer;
        &:hover{
          border-bottom: 1px solid #FFFFFF00;
        }
      }
    }
  }
  & > section > section{
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    margin: -8px 0 0 0;
    @media (max-width:768px){
      grid-template-columns: 1fr;
      margin: 19px 0 0 0;
      gap:38px;
    }
    h1,
    h2,
    h3,
    p{
      font-size: 16px;
      line-height: 30px;
      transform: scale(0.8,1);
      width: calc(100%/0.8);
      transform-origin: top left;
      letter-spacing: .05em;
      font-feature-settings: "palt" 1;
      text-align: justify;
      a{
        border-bottom: 1px solid #FFFFFF;
        padding: 0 0 5px 0;
        &[href^='tel:']{
          border-bottom: none;
        }
        &:hover{
          border-bottom: 1px solid #FFFFFF00;
        }
      }
      @media (max-width:768px){
        font-size: 14px;
        line-height: 26px;
        a{
          &:hover{
            border-bottom: 1px solid #FFFFFF;
          }
        }
      }
    }
    & > div.exh_information{
      & > ul{
        margin: 30px 0;
        & > li{
          display: grid;
          grid-template-columns: 40px 1fr;
          & > p.venue{
            br{
              display: none;
            }
          }
          & > p.tel{
            margin: 0 0 0 -1px;
          }
          & > p.grants{
            & > span{
              display: block;
              &:nth-child(2) > span:first-child{
                margin: 0 !important;
              }
              & > img{
                height: 22.5px;
                object-fit: fill;
                margin: 0.5px 0 0 21.5px;
                vertical-align: text-bottom;
              }
            }
          }
        }
        @media (max-width: 768px) {
          margin: 26px 0;
          &>li{
            grid-template-columns: 35px 1fr;
            & > p.venue{
              br{
                display: inline;
              }
              a{
                margin: 0px 0px 0px -5px;
                padding: 0 0 4px 0;
              }
            }
            & > p.grants{
              & > span{
                & > img{
                  height: 20.2px;
                  margin: 0px 0 0 21.5px;
                  vertical-align: text-bottom;
                }
              }
            }
          }
        }
      }
    }
    & > div.exh_text{
      p{
        margin: 0 0 30px 0;
      }
      @media (max-width: 768px) {
        border-top: 1px solid #FFFFFF;
        padding: 39px 0 20px 0;
        p{
          margin: 0 0 26px 0;
        }
      }

    }
  }
`

const Footer = styled.footer`
  width: 100%;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #040000;
  background: #000;
  display: flex;
  justify-content: space-between;
  padding: 3px 19px 5px 19px;
  box-sizing: border-box;
  p{
    display: inline-block;
    width: auto;
    color: #FFFFFF;
    font-size: 12px;
    &+p{
      font-size: 10px;
      margin: 0 -2.1% 0 0;
      span{
        border-bottom: 1px solid #FFFFFF;
        padding: 0 0 1px 0;
        cursor: pointer;
        &:hover{
          border-bottom: 1px solid #FFFFFF00;
        }
      }
    }
  }
  @media screen and (max-width:768px) {
    padding: 0px 4px 0px 20px;
  }
`

export default Layout
